module.exports = {
  objects: [
    {
      name: 'property',
      namePlural: 'properties',
      id: 8,
      fields: [
        {
          name: 'officialName',
          id: 60,
          type: 'string',
        },
        {
          name: 'coreProviderAgencies',
          id: 77,
          type: 'connections',
          source: 'coreProviderAgency',
          //  requiresOne: ['read:coreProviderName'],
        },
        {
          name: 'directServiceProviders',
          id: 78,
          type: 'connections',
          source: 'directServiceProvider',
        },
        {
          name: 'address',
          id: 80,
          type: 'propertyAddress', // engages permission-backed sanitization in backend
        },
        {
          name: 'phone',
          id: 101,
          type: 'phone',
          requiresOne: ['read:propertyPhone'],
        },
        {
          name: 'nickname',
          id: 102,
          type: 'string',
        },
        {
          name: 'county',
          id: 103,
          type: 'string',
        },
        {
          name: 'livingSituation',
          id: 109,
          type: 'string',
        },
        {
          name: 'miLicensed',
          id: 110,
          type: 'stringBoolean',
        },
        {
          name: 'iddLicensed',
          id: 111,
          type: 'stringBoolean',
        },
        {
          name: 'licenseCapacity',
          id: 112,
          type: 'integer',
        },
        {
          name: 'currentlyHasWomen',
          id: 113,
          type: 'stringBoolean',
        },
        {
          name: 'currentlyHasMen',
          id: 114,
          type: 'stringBoolean',
        },
        {
          name: 'propertyDesign',
          id: 115,
          type: 'string',
        },
        {
          name: 'airConditioning',
          id: 116,
          type: 'string',
        },
        {
          name: 'ramp',
          id: 118,
          type: 'stringBoolean',
        },
        {
          name: 'foundationStyle',
          id: 119,
          type: 'string',
        },
        {
          name: 'patioOrDeck',
          id: 120,
          type: 'stringBoolean',
        },
        {
          name: 'balcony',
          id: 121,
          type: 'stringBoolean',
        },
        {
          name: 'fencedYard',
          id: 122,
          type: 'stringBoolean',
        },
        {
          name: 'garageType',
          id: 123,
          type: 'string',
        },
        {
          name: 'currentNumberOfResidents',
          id: 124,
          type: 'integer',
        },
        {
          name: 'numberOfBedrooms',
          id: 125,
          type: 'integer',
        },
        {
          name: 'numberOfBathrooms',
          id: 126,
          type: 'float',
        },
        {
          name: 'squareFeet',
          id: 127,
          type: 'integer',
        },
        {
          name: 'laundryOnPremises',
          id: 128,
          type: 'stringBoolean',
        },
        {
          name: 'transportationAvailable',
          id: 129,
          type: 'strings',
        },
        {
          name: 'laraLicenseNumber',
          id: 130,
          type: 'string',
        },
        {
          name: 'activeLicense',
          id: 131,
          type: 'stringBoolean',
        },
        {
          name: 'outingsPerWeek',
          id: 139,
          type: 'integer',
        },
        {
          name: 'dateUpdated',
          id: 161,
          type: 'datetime',
        },
        {
          name: 'status',
          id: 164,
          type: 'string',
        },
        {
          name: 'homeManager',
          id: 227,
          type: 'connection',
          source: 'homeManager',
        },
        // Removed per [OHL-35](https://linear.app/atomic-object/issue/OHL-35)
        // {
        //   name: 'supportsCoordinator',
        //   id: 257,
        //   type: 'connection',
        //   source: 'socialWorker',
        //   requiresOne: ['read:socialWorkerContactInfo'],
        // },
        {
          name: 'brokerNotes',
          id: 287,
          type: 'html',
          requiresOne: ['read:brokerNotes'],
        },
        {
          name: 'staffingMornings',
          id: 323,
          type: 'string',
          requiresOne: ['read:staffingRatios'],
        },
        {
          name: 'staffingAfternoons',
          id: 328,
          type: 'string',
          requiresOne: ['read:staffingRatios'],
        },
        {
          name: 'staffingMidnights',
          id: 333,
          type: 'string',
          requiresOne: ['read:staffingRatios'],
        },
        {
          name: 'licensed',
          id: 510,
          type: 'string',
        },
        {
          name: 'zip',
          id: 512,
          type: 'string',
        },
        {
          name: 'miexp',
          id: 529,
          type: 'string',
        },
        {
          name: 'iddexp',
          id: 530,
          type: 'string',
        },
        {
          name: 'hiddenaddress',
          id: 532,
          type: 'string',
          requiresOne: ['read:coreProviderName'],
        },
      ],
    },
    {
      name: 'propertyImage',
      namePlural: 'propertyImages',
      id: 17,
      fields: [
        {
          name: 'image',
          id: 193,
          type: 'imageObject',
        },
        {
          name: 'caption',
          id: 194,
          type: 'string',
        },
        {
          name: 'property',
          id: 275,
          type: 'connection',
          source: 'property',
        },
        {
          name: 'mainPhoto',
          id: 291,
          type: 'boolean',
        },
      ],
    },
    {
      name: 'opening',
      namePlural: 'openings',
      id: 21,
      fields: [
        {
          name: 'id',
          id: 259,
          type: 'integer',
        },
        {
          name: 'property',
          id: 262,
          type: 'connection',
          source: 'property',
        },
        {
          name: 'status',
          id: 263,
          type: 'string',
        },
        {
          name: 'bedroomSituation',
          id: 264,
          type: 'string',
        },
        {
          name: 'bathroomSituation',
          id: 265,
          type: 'strings',
        },
        {
          name: 'openToWomen',
          id: 270,
          type: 'stringBoolean',
        },
        {
          name: 'openToMen',
          id: 271,
          type: 'stringBoolean',
        },
        {
          name: 'additionalInfo',
          id: 272,
          type: 'string',
        },
        {
          name: 'felonyRecordConsidered',
          id: 276,
          type: 'stringBoolean',
          requiresOne: ['read:openingSafetyFields'],
        },
        {
          name: 'alzheimersConsidered',
          id: 277,
          type: 'stringBoolean',
        },
        {
          name: 'substanceUseConsidered',
          id: 278,
          type: 'stringBoolean',
        },
        {
          name: 'behavioralIssuesConsidered',
          id: 279,
          type: 'stringBoolean',
          requiresOne: ['read:openingSafetyFields'],
        },
        {
          name: 'highMedicalNeedsConsidered',
          id: 281,
          type: 'stringBoolean',
        },
        {
          name: 'supportsWheelchair',
          id: 282,
          type: 'stringBoolean',
        },
        {
          name: 'supportsWalker',
          id: 298,
          type: 'stringBoolean',
        },
        {
          name: 'dateUpdated',
          id: 296,
          type: 'datetime',
        },
        {
          name: 'privateComments',
          id: 273,
          type: 'string',
          requiresOne: ['read:providerComments'],
        },
        {
          name: 'brokerNotes',
          id: 274,
          type: 'string',
          requiresOne: ['read:brokerNotes'],
        },
        {
          name: 'avgAge',
          id: 513,
          type: 'string',
        },
        {
          name: 'rent',
          id: 514,
          type: 'string',
        },
        {
          name: 'utilities',
          id: 515,
          type: 'string',
        },
        {
          name: 'utilityCost',
          id: 516,
          type: 'string',
        },
        {
          name: 'securityDeposit',
          id: 517,
          type: 'string',
        },
        {
          name: 'bgCheck',
          id: 518,
          type: 'string',
        },
        {
          name: 'otherExpenses',
          id: 519,
          type: 'string',
        },
        {
          name: 'pets',
          id: 520,
          type: 'string',
        },
        {
          name: 'currentPets',
          id: 521,
          type: 'string',
        },
        {
          name: 'currentSmoking',
          id: 522,
          type: 'string',
        },
        {
          name: 'smokingAllowed',
          id: 523,
          type: 'string',
        },
        {
          name: 'noiseLevel',
          id: 524,
          type: 'string',
        },
        {
          name: 'verbal',
          id: 525,
          type: 'string',
        },
        {
          name: 'activities',
          id: 526,
          type: 'string',
        },
        {
          name: 'supportStaff',
          id: 527,
          type: 'string',
        },
        {
          name: 'staffHours',
          id: 528,
          type: 'string',
        },
      ],
    },
    {
      name: 'coreProvider',
      namePlural: 'coreProviders',
      id: 3,
      fields: [
        {
          name: 'officialName',
          id: 145,
          type: 'string',
        },
        {
          name: 'mailingAddress',
          id: 146,
          type: 'address',
        },
        {
          name: 'website',
          id: 147,
          type: 'url',
        },
        {
          name: 'contactPeople',
          id: 244,
          type: 'connections',
          source: 'contactPerson',
          requiresOne: ['read:coreProviderPersonalContactInfo'],
        },
        {
          name: 'nickname',
          id: 260,
          type: 'string',
        },
      ],
    },
    {
      name: 'directServiceProvider',
      namePlural: 'directServiceProviders',
      id: 10,
      fields: [
        {
          name: 'officialName',
          id: 149,
          type: 'string',
        },
        {
          name: 'mailingAddress',
          id: 150,
          type: 'address',
        },
        {
          name: 'website',
          id: 151,
          type: 'url',
        },
        {
          name: 'contactPeople',
          id: 243,
          type: 'connections',
          source: 'contactPerson',
        },
        {
          name: 'nickname',
          id: 261,
          type: 'string',
        },
        {
          name: 'contacts',
          id: 680,
          type: 'string',
          requiresOne: ['read:brokerNotes'],
        },
      ],
    },
    {
      name: 'contactPerson',
      namePlural: 'contactPeople',
      id: 19,
      fields: [
        {
          name: 'name',
          id: 221,
          type: 'personName',
        },
        {
          name: 'email',
          id: 222,
          type: 'email',
        },
        {
          name: 'mainPhone',
          id: 239,
          type: 'phone',
        },
        {
          name: 'cellPhone',
          id: 240,
          type: 'phone',
        },
        {
          name: 'jobTitle',
          id: 242,
          type: 'string',
        },
      ],
    },
    {
      name: 'homeManager',
      namePlural: 'homeManagers',
      id: 18,
      fields: [
        {
          name: 'name',
          id: 216,
          type: 'personName',
        },
        {
          name: 'email',
          id: 217,
          type: 'email',
          requiresOne: ['read:homeManagerContactInfo'],
        },
        {
          name: 'contactEmail',
          id: 317,
          type: 'email',
          requiresOne: ['read:homeManagerContactInfo'],
        },
        {
          name: 'cellPhone',
          id: 228,
          type: 'phone',
          requiresOne: ['read:homeManagerContactInfo'],
        },
        {
          name: 'notes',
          id: 245,
          type: 'string',
          requiresOne: ['read:homeManagerContactInfo'],
        },
      ],
    },
    {
      name: 'socialWorker',
      namePlural: 'socialWorkers',
      id: 16,
      fields: [
        {
          name: 'name',
          id: 182,
          type: 'personName',
        },
        {
          name: 'email',
          id: 183,
          type: 'email',
        },
        {
          name: 'mainPhone',
          id: 234,
          type: 'phone',
        },
        {
          name: 'cellPhone',
          id: 235,
          type: 'phone',
        },
        {
          name: 'coreProviderAgency',
          id: 251,
          type: 'connection',
          source: 'coreProviderAgency',
        },
        {
          name: 'notes',
          id: 246,
          type: 'string',
        },
      ],
    },
    {
      name: 'contentBlock',
      namePlural: 'contentBlocks',
      id: 22,
      fields: [
        {
          name: 'key',
          id: 305,
          type: 'string',
        },
        {
          name: 'label',
          id: 288,
          type: 'string',
        },
        {
          name: 'content',
          id: 289,
          type: 'html',
        },
        {
          name: 'dateUpdated',
          id: 290,
          type: 'datetime',
        },
      ],
    },
  ],
}
